
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import {mapActions, mapGetters, mapState} from 'vuex';
    import moment from 'moment';
    import { VMenu } from '@/types/Components';
    import { RechnungenOptions } from '@/store/statistik';
    import Beleg from '@/types/Beleg';
    import {SystemEinstellung, SystemEinstellungKey} from '@/types/Einstellung';

    @Component({
        computed: {
            ...mapState('statistik', ['loaders']),
            ...mapState('zahlungsarten', ['arten']),
            ...mapState('zahlungsarten', { zahlungsartenLoaders: 'loaders' }),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('statistik', ['printRechnungen', 'exportRechnungen', 'exportFibuRechnungen']),
            ...mapActions('zahlungsarten', ['loadZahlungsarten']),
        },
    })
    export default class Rechnungen extends Vue {
        @Prop() public visible!: boolean;

        public $refs!: {
            zeitraumMenu: VMenu;
        };

        public readonly sortierung: { text: string; value: keyof Beleg | 'nachname' }[] = [
            { text: 'Beleg Nr.', value: 'belegnr' },
            { text: 'Nachname', value: 'nachname' },
        ];

        public loadZahlungsarten!: () => void;
        public printRechnungen!: (payload: { options: RechnungenOptions }) => void;
        public exportRechnungen!: (payload: { options: RechnungenOptions }) => void;
        public exportFibuRechnungen!: (payload: { options: RechnungenOptions }) => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;

        public zeitraumMenu = false;

        public options: RechnungenOptions = {
            zeitraum: [
                moment().subtract(30, 'days').format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD'),
            ],
            zahlungsart: '',
            sortierung: 'belegnr',
            offen: false,
            variante: 1
        };

        public get canPrint(): boolean {
            return this.options.zeitraum.length === 2;
        }

        public get maxZeitraum(): string {
            return moment().format('YYYY-MM-DD');
        }

        public get maxJahrgang(): number {
            return moment().year();
        }

        public get zeitraumLabel(): string {
            return this.options.zeitraum.length
                ? 'von ' + this.options.zeitraum.sort((a, b) => a.localeCompare(b)).map((date) => {
                    const [year, month, day] = date.split('-');
                    return `${day}.${month}.${year}`;
                }).join(' bis ')
                : '';
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.loadZahlungsarten();
                var fibuVariante = this.getSystemEinstellung('fibu_variante').value;
                if (fibuVariante) {
                  this.options.variante = fibuVariante;
                }
            }
        }

        @Watch('zeitraum')
        public onChangeZeitraum(dates: [string, string]): void {
            if (dates?.length === 2) {
                this.options.zeitraum = dates;
            }
        }

        public saveZeitraum(date: [string, string]): void {
            this.options.zeitraum = date;
            this.$refs.zeitraumMenu.save(date);
        }

        public onClickPrint(): void {
            const options = {
                ...this.options,
                zeitraum: this.options.zeitraum.sort((a, b) => a.localeCompare(b)),
            };

            this.printRechnungen({ options });
        }

        public onClickExport(): void {
            const options = {
                ...this.options,
                zeitraum: this.options.zeitraum.sort((a, b) => a.localeCompare(b)),
            };

            this.exportRechnungen({ options });
        }

        public onClickExportFibu(): void {
            const options = {
                ...this.options,
                zeitraum: this.options.zeitraum.sort((a, b) => a.localeCompare(b)),
            };

            this.exportFibuRechnungen({ options });
        }
    }
